import { calculatePriceMargin } from "./index";

export function formatMrGenericConnectionResource(productData, normalizedSizesDictionary, retailerMargin) {
  const { margin } = retailerMargin;

  let isAllStandardSizes = true;
  const sizes = productData.sizes.map(s => {
    const { size, quantity, id } = s;
    // eslint-disable-next-line security/detect-object-injection
    const normalized = normalizedSizesDictionary[size];
    if (isAllStandardSizes && !normalized) {
      isAllStandardSizes = false;
    }

    return {
      id,
      size,
      quantity,
      normalized: normalized || "-"
    };
  });

  const incomingWholesale = Number(productData.data.wholesale_price).toFixed(2);
  const retail = Number(Number(productData.data.list_price).toFixed(2));
  const { isWholesaleCalculatedFromMargin, wholesale } = calculatePriceMargin({
    wholesale: incomingWholesale,
    margin,
    retail
  });

  return {
    condition: productData.data.condition,
    title: productData.data.product_name,
    color: productData.data.brand_color,
    normalized_color: productData.data.normalized_color,
    composition: productData.data.composition,
    incomingBrand: productData.data.brand,
    brand: productData?.data?.brand && `${productData.data.brand}` || productData?.brand && `${productData.brand}`,
    retailerDescription: `${productData.data.description}`,
    sizes,
    sku: productData.data.style_number,
    images: productData.images,
    wholesale,
    incomingPrices: {
      wholesale: incomingWholesale,
      retail,
      compareAtPrice: Number(Number(productData.data.msrp).toFixed(2))
    },
    hasWholesale: wholesale > 0,
    isAllStandardSizes,
    isWholesaleCalculatedFromMargin,
  };
}
